import * as DSAssetFamilies from 'customer-data-filters-ui/filterQueryFormat/DSAssetFamilies/DSAssetFamilies';
import EditorBehavioralEventRelatedConditionsGroup from './EditorBehavioralEventRelatedConditionsGroup';
import EditorCTARelatedConditionsGroup from './EditorCTARelatedConditionsGroup';
import EditorEmailSubscriptionRelatedConditionsGroup from './EditorEmailSubscriptionRelatedConditionsGroup';
import EditorFormSubmissionRelatedConditionsGroup from './EditorFormSubmissionRelatedConditionsGroup';
import EditorMarketingEmailRelatedConditionsGroup from './EditorMarketingEmailRelatedConditionsGroup';
import EditorPageViewRelatedConditionsGroup from './EditorPageViewRelatedConditionsGroup';
import EditorCommunicationSubscriptionRelatedConditionsGroup from './EditorCommunicationSubscriptionRelatedConditionsGroup';
import SegmentationFiltersInstanceContext from '../../state/SegmentationFiltersInstanceContext';
import { useContext, useMemo } from 'react';
import EditorBehavioralEventRelatedConditionsGroupResponsive from './EditorBehavioralEventRelatedConditionsGroupResponsive';
import EditorCommunicationSubscriptionRelatedConditionsGroupResponsive from './EditorCommunicationSubscriptionRelatedConditionsGroupResponsive';
import EditorCTARelatedConditionsGroupResponsive from './EditorCTARelatedConditionsGroupResponsive';
import EditorEmailSubscriptionRelatedConditionsGroupResponsive from './EditorEmailSubscriptionRelatedConditionsGroupResponsive';
import EditorFormSubmissionRelatedConditionsGroupResponsive from './EditorFormSubmissionRelatedConditionsGroupResponsive';
import EditorMarketingEmailRelatedConditionsGroupResponsive from './EditorMarketingEmailRelatedConditionsGroupResponsive';
import EditorPageViewRelatedConditionsGroupResponsive from './EditorPageViewRelatedConditionsGroupResponsive';
import { jsx as _jsx } from "react/jsx-runtime";
const EditorEventBasedRelatedConditionsGroup = props => {
  const {
    condition,
    conditionPath,
    dataSeleniumInfo,
    filterFamily
  } = props;
  const {
    props: {
      useOnePanel
    }
  } = useContext(SegmentationFiltersInstanceContext);
  const relatedConditionsGroupComponentsMap = useMemo(() => {
    return {
      [DSAssetFamilies.FORM]: EditorFormSubmissionRelatedConditionsGroup,
      [DSAssetFamilies.PAGE_VIEW]: EditorPageViewRelatedConditionsGroup,
      [DSAssetFamilies.EMAIL_CAMPAIGN]: EditorMarketingEmailRelatedConditionsGroup,
      [DSAssetFamilies.EMAIL_SUBSCRIPTION]: EditorEmailSubscriptionRelatedConditionsGroup,
      [DSAssetFamilies.SMS_SUBSCRIPTION]: EditorCommunicationSubscriptionRelatedConditionsGroup,
      [DSAssetFamilies.WHATSAPP_SUBSCRIPTION]: EditorCommunicationSubscriptionRelatedConditionsGroup,
      [DSAssetFamilies.CTA]: EditorCTARelatedConditionsGroup,
      [DSAssetFamilies.EVENT]: EditorBehavioralEventRelatedConditionsGroup
    };
  }, []);
  const relatedConditionsGroupComponentsMapSinglePanel = useMemo(() => {
    return {
      [DSAssetFamilies.CTA]: EditorCTARelatedConditionsGroupResponsive,
      [DSAssetFamilies.FORM]: EditorFormSubmissionRelatedConditionsGroupResponsive,
      [DSAssetFamilies.EMAIL_CAMPAIGN]: EditorMarketingEmailRelatedConditionsGroupResponsive,
      [DSAssetFamilies.EMAIL_SUBSCRIPTION]: EditorEmailSubscriptionRelatedConditionsGroupResponsive,
      [DSAssetFamilies.EVENT]: EditorBehavioralEventRelatedConditionsGroupResponsive,
      [DSAssetFamilies.PAGE_VIEW]: EditorPageViewRelatedConditionsGroupResponsive,
      [DSAssetFamilies.SMS_SUBSCRIPTION]: EditorCommunicationSubscriptionRelatedConditionsGroupResponsive,
      [DSAssetFamilies.WHATSAPP_SUBSCRIPTION]: EditorCommunicationSubscriptionRelatedConditionsGroupResponsive
    };
  }, []);
  const RelatedConditionsGroup = useOnePanel ?
  // @ts-expect-error `filterFamily` is not typed specifically enough
  relatedConditionsGroupComponentsMapSinglePanel[filterFamily] :
  // @ts-expect-error `filterFamily` is not typed specifically enough
  relatedConditionsGroupComponentsMap[filterFamily];
  if (RelatedConditionsGroup) {
    return /*#__PURE__*/_jsx(RelatedConditionsGroup, {
      filterFamily: filterFamily,
      condition: condition,
      conditionPath: conditionPath,
      dataSeleniumInfo: dataSeleniumInfo
    });
  }
  return null;
};
export default EditorEventBasedRelatedConditionsGroup;